import { gql } from '@apollo/client';

export const GET_PLATFORM_PLAN_IDS = gql`
  query GetPlatformPlanIds(
    $where: JSON
    $groupBy: [String]
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    platformPlans(
      where: $where
      groupBy: $groupBy
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      id
    }
  }
`;

export const GET_PLATFORM_PLANS = gql`
  query GetPlatformPlans($where: JSON) {
    platformPlans(where: $where) {
      id
      name
      description
      products {
        id
        type
        price
        billingFrequency
        billingTiming
        billTo
      }
    }
  }
`;

import type { PlatformProduct } from './planProduct.types';

export interface PlatformPlan {
  id: string;
  name: string;
  description?: string;
  products: PlatformProduct[];
}
